import { Field } from '@/components/ui/field';
import { Textarea } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const I18N_PREFIX = 'integrations.googleDrive.sharing.invite';

interface DriveExternalEmailsFieldProps {
  value: string;
  onChange: (value: string) => void;
  invalidEmails: string[];
}

const DriveExternalEmailsField = ({
  value,
  onChange,
  invalidEmails,
}: DriveExternalEmailsFieldProps) => {
  const { t } = useTranslation();

  return (
    <Field
      label={t(`${I18N_PREFIX}.externalEmailsLabel`)}
      helperText={t(`${I18N_PREFIX}.externalEmailsHint`)}
      errorText={
        invalidEmails.length > 0
          ? t(`${I18N_PREFIX}.invalidEmails`, { emails: invalidEmails.join(', ') })
          : undefined
      }
    >
      <Textarea
        variant="outline"
        placeholder="name@example.com, name@example.com"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={3}
      />
    </Field>
  );
};

export default DriveExternalEmailsField;
